var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTickinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 31",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.797,
    cy: 15.957,
    rx: 14.072,
    ry: 14.019
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeLinecap: "square",
    strokeLinejoin: "round",
    points: "10.773 18.11 14.448 20.963 20.821 10.95"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTickinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tick.inline.8481dd6b562f964d379671a4a476a6a5.svg";